import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import CreateButton from '../buttons/CreateButton';
import ZoneCreateTab from './ZoneCreateTab';
import { zonePropertiesType } from '../../types';
import withPrivileges from '../../hocs/withPrivileges';
import Privileges from '../../utils/Privileges';

CreateZoneRow.propTypes = {
    zoneProps: zonePropertiesType.isRequired,
};

function CreateZoneRow(props) {
    const {
        zoneProps,
    } = props;
    const { t } = useTranslation();
    const [isCreateVisible, setCreateVisible] = useState(false);
    const actionHandler = () => setCreateVisible(!isCreateVisible);
    return (
        <div className="create-zone-row">
            <CreateButton onAction={actionHandler} isCreateVisible={isCreateVisible}><FontAwesomeIcon icon="plus" />&nbsp;{t('zones.create-zone')}</CreateButton>
            {isCreateVisible && (
                <ZoneCreateTab
                    hideHandler={() => setCreateVisible(false)}
                    zoneProps={zoneProps}
                />
            )}
        </div>
    );
}

export default withPrivileges([Privileges.ZONE_EDIT_ALL])(CreateZoneRow);
